import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {  db } from "../utils/firebase";

import Header from "../components/Header";
import Toast from "../components/Toast";
import { onValue, ref, push, set } from "firebase/database";
import { SHA256 } from "crypto-js";

const LoginPage = () => {
  const navigate = useNavigate();

  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [name, setName] = useState("");
  const [pass, setPass] = useState("");
  const [userData, setUserData] = useState([]);

  useEffect(() => {
    // Fetch data from Firebase database
    const dataRef = ref(db, "userdata");
    onValue(dataRef, (snapshot) => {
      const dataVal = snapshot.val();
      if (dataVal) {
        setUserData(Object.values(dataVal));
      }
    });
  }, []);

  const handleError = () => {
    setShowErrorToast(true);
    setTimeout(() => {
      setShowErrorToast(false);
    }, 3000);
  };

  const handleSubmit = async () => {
    // console.log(name, pass);
    if (name && pass) {
      try {
        const result = userData.find(
          (user) => user.name.toLowerCase() === name.toLowerCase()
        );
        // console.log(result)
        if (result) {
          let rPass = result.pass;
          let hashValue = await SHA256(pass).toString();
          if (hashValue === rPass) {
            // If password matches, store the user ID in local storage
            localStorage.setItem("username", name);
            navigate("/page");
          } else {
            setErrMessage("password incorrect!");
            handleError();
          }
        } else {
          setErrMessage("Error! user not found.");
          handleError();
        }
      } catch (error) {
        handleError();
      }
    } else {
      setErrMessage("details not complete!");
      handleError();
    }
  };

  return (
<div className="min-h-screen bg-[#F5F7FB] relative overflow-hidden">
  <Header btn={"Sign Up"} path={"/signup"} />

  {/* Background Blur */}
  <div className="absolute top-[-120px] left-[-120px] w-[260px] h-[260px] bg-[#4F46E5]/10 rounded-full blur-3xl"></div>

  <div className="absolute bottom-[-120px] right-[-120px] w-[260px] h-[260px] bg-[#14B8A6]/10 rounded-full blur-3xl"></div>

  {/* Main Section */}
  <div className="relative z-10 flex items-center justify-center min-h-[84vh] px-6 pt-[82px] pb-4">
    
    <div className="w-full max-w-xl bg-white/85 backdrop-blur-xl rounded-[24px] shadow-[0_10px_40px_rgba(0,0,0,0.06)] border border-white px-8 py-7 sm:px-10 sm:py-8">
      
      {/* Heading */}
      <div className="text-center">
        
        <h1 className="text-2xl font-black text-gray-800 tracking-tight">
          Welcome Back
        </h1>

        <p className="mt-2 text-gray-500 text-sm">
          Login to continue to CheXCare
        </p>
      </div>

      {/* Form */}
      <div className="mt-7 space-y-5">
        
        {/* Name */}
        <div>
          <label className="text-sm font-semibold text-gray-700">
            Full Name
          </label>

          <input
            type="text"
            placeholder="Enter your name"
            onChange={(e) => {
              setName(e.target.value);
            }}
            className="mt-2 w-full h-[46px] rounded-xl border border-gray-200 bg-gray-50 px-4 outline-none focus:border-[#4F46E5] focus:bg-white transition-all duration-300"
          />
        </div>

        {/* Password */}
        <div>
          <div className="flex items-center justify-between">
            
            <label className="text-sm font-semibold text-gray-700">
              Password
            </label>

            <a
              href="#"
              className="text-xs text-[#4F46E5] hover:underline"
            >
              Forgot Password?
            </a>
          </div>

          <input
            type="password"
            placeholder="Enter your password"
            onChange={(e) => {
              setPass(e.target.value);
            }}
            className="mt-2 w-full h-[46px] rounded-xl border border-gray-200 bg-gray-50 px-4 outline-none focus:border-[#4F46E5] focus:bg-white transition-all duration-300"
          />
        </div>

        {/* Button */}
        <button
          onClick={() => handleSubmit()}
          className="w-full mt-2 h-[48px] rounded-xl bg-gradient-to-r from-[#4F46E5] to-[#6366F1] text-white font-semibold shadow-md hover:shadow-lg hover:scale-[1.01] transition-all duration-300"
        >
          Log In
        </button>

        {/* Signup */}
        <p className="text-center text-sm text-gray-500 pt-1">
          Don’t have an account?{" "}

          <a
            href="/signup"
            className="text-[#4F46E5] font-semibold hover:underline"
          >
            Sign Up
          </a>
        </p>
      </div>
    </div>
  </div>

  {/* Toast */}
  {showErrorToast && (
    <Toast
      message={errMessage}
      type="error"
      onClose={() => setShowErrorToast(false)}
    />
  )}
</div>
  );
};

export default LoginPage;
